import $ from 'jquery';
import Environment from '../environment';
import Eventable from '../eventable';
import '../lib/spatialNavigation';
import { getLogger } from '../logging/logger';

const { SpatialNavigation } = window;
const logger = getLogger('InputManager');

export const DEFAULT_SECTION_ID = 'page';

class InputManager extends Eventable {
	get Keys() {
		return {
			Back: 8,
			Enter: 13,
			Left: 37,
			Up: 38,
			Right: 39,
			Down: 40,
		};
	}

	get KeyDirections() {
		return {
			8: 'Back',
			13: 'Enter',
			37: 'Left',
			38: 'Up',
			39: 'Right',
			40: 'Down',
		};
	}

	get KeyNumbers() {
		return {
			48: 0,
			49: 1,
			50: 2,
			51: 3,
			52: 4,
			53: 5,
			54: 6,
			55: 7,
			56: 8,
			57: 9,
		};
	}

	constructor() {
		logger.log('[constructor]');

		super();

		// Spatial navigator configuration
		SpatialNavigation.init();
		SpatialNavigation.set({
			straightOverlapThreshold: 0.15,
		});
		SpatialNavigation.add(DEFAULT_SECTION_ID, {
			selector: '#page .btn:not(:disabled):not(.disabled)',
			rememberSource: true,
			restrict: 'self-first',
			defaultElement: '#page .btn',
		});
		SpatialNavigation.setDefaultSection(DEFAULT_SECTION_ID);

		// Add key listeners on window
		window.addEventListener('keydown', this.onKeyEvent.bind(this), true);
		window.addEventListener('keyup', this.onKeyEvent.bind(this), true);

		this.pointerDetected = false;
		$(document.body).one('pointerdown mousemove', this.onPointerDetected.bind(this));
	}

	/**
	 * Dispatch events when a user presses directional buttons
	 */
	onKeyEvent(event) {
		logger.log('[onKeyEvent]', { event });

		const button = this.KeyDirections[event.keyCode];
		const number = this.KeyNumbers[event.keyCode];
		const type = event.type.replace('key', ''); // 'up' || 'down'

		if (button) {
			const isInput = event && event.target && event.target.tagName === 'INPUT';
			if (button === 'Back' && !isInput) {
				/**
				 * Prevent default browser behaviour for the backspace button.
				 * We will force the user back to the home page or do special handling
				 * for the Back button.
				 */
				event.preventDefault();
			}

			const eventName = `${button.toLowerCase()}-${type.toLowerCase()}`;
			logger.debug('[Handle Button]', { eventName, button, type });
			this.trigger(eventName, event);
			if (type === 'down') {
				// Trigger event with just the button name for convience
				this.trigger(button.toLowerCase(), event);
			}
		} else if (Number.isFinite(number)) {
			const eventName = `${number.toString()}-${type.toLowerCase()}`;
			logger.debug('[Handle Number]', { eventName, number, type });

			this.trigger(eventName, event);
			if (type === 'down') {
				// Trigger event with just the button number for convience
				this.trigger(number.toString(), event);
			}
		}
	}

	onPointerDetected() {
		logger.log('[onPointerDetected]');
		this.pointerDetected = true;
	}

	clear(...args) {
		return SpatialNavigation.clear(...args);
	}

	set(...args) {
		return SpatialNavigation.set(...args);
	}

	add(...args) {
		try {
			return SpatialNavigation.add(...args);
		} catch (e) {
			return false;
		}
	}

	remove(...args) {
		return SpatialNavigation.remove(...args);
	}

	disable(...args) {
		return SpatialNavigation.disable(...args);
	}

	enable(...args) {
		return SpatialNavigation.enable(...args);
	}

	pause(...args) {
		return SpatialNavigation.pause(...args);
	}

	resume(...args) {
		return SpatialNavigation.resume(...args);
	}

	focus(...args) {
		if (Environment.isSetTopBox()) {
			return SpatialNavigation.focus(...args);
		}
		logger.info('[Only focus on STB devices]');
		return undefined;
	}

	makeFocusable(...args) {
		return SpatialNavigation.makeFocusable(...args);
	}

	move(...args) {
		return SpatialNavigation.move(...args);
	}

	setDefaultSection(...args) {
		return SpatialNavigation.setDefaultSection(...args);
	}
}

export default new InputManager();
